import { GLOBAL_URL } from './../shared/constants/dataServiceUrl';

export const getMappedRoute = (pathname: string = '', nestedRoutes: any[] = []): string => {
  return pathname.split('/')
    .filter((routeName: string): boolean =>
      nestedRoutes
        .findIndex(({ routeName: rName }: any): boolean => rName === routeName) >= 0,
    )[0];
};

const REQUIRED_PROVIDER_DATA_FROM_LOCAL = [
  'Provider/Claim/GetClaimDraftList',
];

export const shouldSetProviderDataFromLocalStorage = (url: string): boolean => {
  const { CRM_BASE_URL = '' } = GLOBAL_URL;
  return REQUIRED_PROVIDER_DATA_FROM_LOCAL.includes(url.replace(CRM_BASE_URL, ''));
};
